/**
 * @generated SignedSource<<5d65da5db2e629eca9cacc11aade644f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectsEmptyState_team$data = {
  readonly id: string;
  readonly portfolio: {
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentType": "ProjectsEmptyState_team";
};
export type ProjectsEmptyState_team$key = {
  readonly " $data"?: ProjectsEmptyState_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectsEmptyState_team">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "portfolioPath"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectsEmptyState_team",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "path",
          "variableName": "portfolioPath"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "portfolio",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};
})();

(node as any).hash = "359cb35506fd85878d32a6d27094400f";

export default node;
